/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 *  - STATUS_CHOOSING_TRADER: Order is waiting till it will be assigned to trader.
 *  - STATUS_WAITING_TRADER_RESPONSE: Order was assigned to trader and is now waiting for trader to respond.
 *  - STATUS_SPLIT: Parent order was split into child orders.
 *  - STATUS_APPROVED: Трейдер утверждает что выполнил выплату, и ожидает одобрения.
 *  - STATUS_CANCELLED: Заявка до принятия трейдером в работу.
 *  - STATUS_INVESTIGATION: Спор направлен в саппорт и будет рассмотрен.
 *  - STATUS_INVESTIGATION_DECLINED: По результатам рассмотрения спора, выплата отклонена.
 *  - STATUS_INVESTIGATION_APPROVED: По результатам рассмотрения спора, выплата одобрена.
 */
export enum PayoutCommonOrderV1Status {
    STATUS_UNSPECIFIED = 'STATUS_UNSPECIFIED',
    STATUS_CHOOSING_TRADER = 'STATUS_CHOOSING_TRADER',
    STATUS_WAITING_TRADER_RESPONSE = 'STATUS_WAITING_TRADER_RESPONSE',
    STATUS_EXPIRED = 'STATUS_EXPIRED',
    STATUS_IN_WORK = 'STATUS_IN_WORK',
    STATUS_SPLIT = 'STATUS_SPLIT',
    STATUS_APPROVED = 'STATUS_APPROVED',
    STATUS_CANCELLED = 'STATUS_CANCELLED',
    STATUS_COMPLETE = 'STATUS_COMPLETE',
    STATUS_INVESTIGATION = 'STATUS_INVESTIGATION',
    STATUS_INVESTIGATION_DECLINED = 'STATUS_INVESTIGATION_DECLINED',
    STATUS_INVESTIGATION_APPROVED = 'STATUS_INVESTIGATION_APPROVED',
}
